import React from "react";

/**
 * Urna de la fila de acciones (votar una postulación). Era un glyph relleno en
 * una grilla de 512 que a 4,5rem ya se leía apretado y al tamaño del resto de
 * la fila quedaba ilegible: ahora es de la misma familia que sus vecinos
 * (grilla de 24, trazo de 2, `currentColor`).
 */
export default function VoteIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ ...props.style, cursor: "pointer" }}
      {...props}
    >
      <path d="M9 12l2 2 4-4" />
      <path d="M5 7a2 2 0 012-2h10a2 2 0 012 2v12H5V7z" />
      <path d="M22 19H2" />
    </svg>
  );
}

VoteIcon.defaultProps = {
  height: `2.2rem`,
  width: `2.2rem`,
  color: "currentColor",
};
